import { createSlice } from "@reduxjs/toolkit";

const myTimesheetSlice = createSlice({
    name: "myTimesheet",
    initialState: {
        isLoading: false,
        taskListOptions: [],
        myTimesheetList: [],
        timesheetCalendar: [],
        timesheetByDay: [],
        myTimesheetById: [],
        myTimesheetAllList: [],
        timesheetDetailsByEmp: []
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setTaskListOptions(state, action) {
            state.taskListOptions = action.payload;
        },
        setMyTimesheetList(state, action) {
            state.myTimesheetList = action.payload;
        },
        setTimesheetCalendar(state, action) {
            state.timesheetCalendar = action.payload;
        },
        setTimesheetByDay(state, action) {
            state.timesheetByDay = action.payload;
        },
        setMyTimesheetById(state, action) {
            state.myTimesheetById = action.payload;
        },
        setMyTimesheetAllList(state, action) {
            state.myTimesheetAllList = action.payload;
        },
        setTimesheetDetailsByEmp(state, action) {
            state.timesheetDetailsByEmp = action.payload;
        },
    },
});

export const {
    setIsLoading,
    setTaskListOptions,
    setMyTimesheetList,
    setTimesheetCalendar,
    setTimesheetByDay,
    setMyTimesheetById,
    setMyTimesheetAllList,
    setTimesheetDetailsByEmp
} = myTimesheetSlice.actions;

export default myTimesheetSlice.reducer;